import React from "react";
import { ChevronDownIcon } from "../../Icons/ChevronDownIcon";
var TableDataCell = function (props) {
    var id = props.id, style = props.style, className = props.className, children = props.children, colSpan = props.colSpan, showIcon = props.showIcon;
    return (React.createElement("td", { id: id, style: style, colSpan: colSpan, className: showIcon ? "td-chevron-icon" : className },
        showIcon && React.createElement(ChevronDownIcon, { size: "small" }),
        children));
};
export default TableDataCell;
//# sourceMappingURL=DataTableCell.js.map